import _ from 'lodash';

import serviceRes from '../resources/service.resource';
import Selector, {selectorTpl, REQUIRED_IMPORTS} from './selector/selector.component';

class ServiceSelectorComponent extends Selector {
  constructor($log, ServiceResource, gettextCatalog) {
    'ngInject';
    super(gettextCatalog.getString('Palvelu'));

    this.$log = $log;

    this.ServiceResource = ServiceResource;

    /**
     * Service set by the parent component.
     * @type {Service}
     */
    this.service = null;

    /**
     * Callback to call when object is selected.
     * @type {Function}
     */
    this.selectCallback = null;

    /**
     * An initial value for service, just Id.
     * @type {?Number}
     */
    this.initialId = null;

    /**
     * List of allowed service ids.
     * @type {?Number}
     */
    this.idFilter = null;

    /**
     * Should the selector automatically select the first default service.
     * @type {boolean}
     */
    this.selectDefault = false;
  }

  loadData() {
    return this.ServiceResource.getAll().then(services => {
      return services.list
      .filter(service => this.idFilter == null || this.idFilter.includes(service.id))
      .map(service => {
        return { label: service.name, obj: service };
      })
      .sort((s1, s2) => {
        // Guard against breaking with null name
        if (s1.obj.name == null) {
          return 1;
        }
        if (s2.obj.name == null) {
          return -1;
        }
        return s1.obj.name.localeCompare(s2.obj.name, 'fi');
      });
    })
    .catch(e => this.$log.error("Fail selector loadData", e));
  }

  $onInit() {
    this.object = this.service;
    super.$onInit();
  }

  $onChanges() {
    this.object = this.service == null? null : this.objs.find(s => s.obj.id === this.service.id);
    super.$onChanges();
  }

  onSelect() {
    super.onSelect();
    this.selectCallback({service: this.object})
  }

  onPostInit() {
    // Preselect either a set initial service
    if (this.service == null && this.initialId != null) {
      this.object = this.objs.find(s => s.obj != null && s.obj.id === this.initialId);
    }
    // ...a default service
    else if (this.selectDefault && this.objs.length > 0) {
      this.object = this.objs.find(s => s.obj != null && s.obj.is_default === true);
    }
    // ...or a service with lowest order_number
    else if (this.objs.length > 0) {
      // Note the copy of array with concat() before inplace sort to prevent main order from changing
      this.object = this.objs.concat().sort((a, b) => a.obj.order - b.obj.order)[0];
    }

    this._setObject();

    this.loaded = true;
    this.selectCallback({service: this.object});
  }
}

const config = {
  templateUrl: selectorTpl,
  controller: ServiceSelectorComponent,
  bindings: {
    service: '<',
    initialId: '<?',
    idFilter: '<?',
    selectCallback: '&',
    extraClasses: '@?',
    selectDefault: '<?'
  }
};

const mod = angular.module('app.component.serviceSelector', _.union(REQUIRED_IMPORTS, [serviceRes]))

.component('serviceSelector', config)

;

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/components/service-selector.component.js